import { withViewerScope, type ViewerScopedQueryOptions } from "@/lib/viewer-scoped-query";
import { orpc } from "@/utils/orpc.client";
import { QUERY_GC_TIMES, QUERY_REFETCH_INTERVALS, QUERY_STALE_TIMES } from "@/utils/query-policies";

export function getListsItemsQueryOptions(options: ViewerScopedQueryOptions = {}) {
  const queryOptions = {
    ...orpc.lists.getListsItems.queryOptions({}),
    enabled: options.enabled,
    staleTime: QUERY_STALE_TIMES.listMembership,
    gcTime: QUERY_GC_TIMES.listMembership,
    refetchOnMount: true,
    refetchInterval: QUERY_REFETCH_INTERVALS.listMembership,
    refetchIntervalInBackground: false,
  };

  return withViewerScope(queryOptions, options.viewerId);
}
